// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_1ZioURwnFjqwTDen_4MKRi"};